import { Button } from 'react-bootstrap';
import { ItemType } from './types';

export default function ItemsList({
  items,
  onDeleteItem,
  onDeleteRelationships,
}: {
  items: Record<string, ItemType>;
  onDeleteItem: (id: string) => Promise<void>;
  onDeleteRelationships: (id: string) => Promise<void>;
}) {
  return Object.values(items).map((item) => (
    <div key={item.id} className="d-flex align-items-center mb-2">
      <div className="flex-grow-1">{item.id}</div>
      <div className="d-flex gap-2">
        <Button
          variant="danger"
          size="sm"
          onClick={() => onDeleteItem(item.id)}
        >
          Delete Item
        </Button>
        <Button
          variant="warning"
          size="sm"
          onClick={() => onDeleteRelationships(item.id)}
        >
          Reset Relationships
        </Button>
      </div>
    </div>
  ));
}
